export const product =[
    { id: 101, title: 'Mouse', categoryId: 11,categoryName:'دیجیتال', price: 200, editMode:false },
    { id: 102, title: 'js book', categoryId: 12,categoryName:'کتاب', price: 120, editMode:false },
    {id: 103 ,title:'react t-shirt',categoryId:13,categoryName:'پوشاک',price:150 , editMode:false}
]
export const emptyProduct ={id:'',title:'', categoryId:'',categoryName:'', price:"",editMode:''}
export const categories = [
    { id: 11, title: 'دیجیتال'},
    { id: 12, title: 'کتاب' },
    { id: 13, title: 'پوشاک' },
];
